import View from './View.js';
import icons from 'url:../../img/icons.svg'; //Parcel 2

class AddRecipeView extends View {
  _parentElement = document.querySelector('.upload');
  _message = 'Recipe was successfully uploaded :)';

  _window = document.querySelector('.add-recipe-window');
  _overlay = document.querySelector('.overlay');
  _btnOpen = document.querySelector('.nav__btn--add-recipe');
  _btnClose = document.querySelector('.btn--close-modal');

  constructor() {
    // child class, requires super for this keyword
    super();
    this._addHandlerShowWindow();
    this._addHandlerHideWindow();
  }
  // function to be called as soon as page loads
  // doesn't require controller
  // only used in this class, so adding underscore for protected

  toggleWindow() {
    this._overlay.classList.toggle('hidden');
    this._window.classList.toggle('hidden');
  }
  _addHandlerShowWindow() {
    this._btnOpen.addEventListener('click', this.toggleWindow.bind(this));
  }

  _addHandlerHideWindow() {
    this._btnClose.addEventListener('click', this.toggleWindow.bind(this));
    this._overlay.addEventListener('click', this.toggleWindow.bind(this));
  }

  addHandlerUpload(handler) {
    // listen for event on the parent element - the upload form itself
    this._parentElement.addEventListener('submit', function (e) {
      e.preventDefault();
      const dataArray = [...new FormData(this)]; //returns a weird object, so spreading it into array
      // data needs to be sent to the model
      const data = Object.fromEntries(dataArray);
      handler(data);
    });
  }

  // every view that renders something to user interface needs the generateMarkup method
  _generateMarkup() {}
}

export default new AddRecipeView();
